import { useState } from 'react';

export default function ArticleContent() {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Tổng quan', icon: 'ri-roadster-line' },
    { id: 'companies', label: 'Hãng xe uy tín', icon: 'ri-building-line' },
    { id: 'driving', label: 'Luật giao thông', icon: 'ri-traffic-light-line' },
    { id: 'tips', label: 'Mẹo tiết kiệm', icon: 'ri-money-dollar-circle-line' }
  ];

  return (
    <article className="bg-white">
      {/* Article Header */}
      <header className="mb-8">
        <div className="flex items-center gap-3 mb-4">
          <span className="bg-orange-100 text-orange-700 text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap">
            Kinh nghiệm thực tế
          </span>
          <span className="text-sm text-gray-500">Cập nhật: 15/01/2025</span>
        </div>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-4 leading-tight">
          Hướng dẫn toàn diện thuê xe & lái xe tại Mỹ: Kinh nghiệm từ chuyên gia du lịch
        </h1>
        
        <div className="flex items-center gap-4 mb-6">
          <div className="flex items-center gap-2">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center text-white font-bold">
              MH
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">Mai Hương - Chuyên gia Du lịch</p>
              <p className="text-xs text-gray-500">12 năm kinh nghiệm du lịch Mỹ & tư vấn thuê xe</p>
            </div>
          </div>
        </div>

        <div className="w-full h-96 rounded-xl overflow-hidden mb-6">
          <img
            src="https://public.readdy.ai/ai/img_res/2d87f09dee3d5abd53ec2c2ac0c34062.jpg"
            alt="Thuê xe tại Mỹ"
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="bg-orange-50 border-l-4 border-orange-600 p-6 rounded-r-lg">
          <p className="text-base leading-relaxed text-gray-700">
            <strong className="text-orange-900">Sau 12 năm du lịch khắp nước Mỹ</strong>, tôi đã thuê xe hơn 50 lần tại các bang khác nhau và tích lũy được vô số kinh nghiệm quý báu. Trong bài viết này, tôi sẽ chia sẻ tất cả những gì bạn cần biết để thuê xe và lái xe an toàn, tiết kiệm tại Mỹ.
          </p>
        </div>
      </header>

      {/* Tab Navigation */}
      <div className="mb-8">
        <div className="grid grid-cols-2 gap-3">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-3 px-6 py-4 text-sm font-medium transition-all cursor-pointer rounded-lg border-2 ${
                activeTab === tab.id
                  ? 'bg-orange-600 text-white border-orange-600 shadow-lg'
                  : 'bg-white text-gray-600 border-gray-200 hover:border-orange-300 hover:text-orange-600'
              }`}
            >
              <i className={`${tab.icon} text-xl`}></i>
              <span className="font-semibold">{tab.label}</span>
              {activeTab === tab.id && (
                <i className="ri-check-line text-xl ml-auto"></i>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="prose prose-lg max-w-none">
        {activeTab === 'overview' && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Tại sao nên thuê xe khi du lịch Mỹ?</h2>
            
            <div className="bg-gradient-to-r from-blue-50 to-teal-50 border border-blue-200 rounded-xl p-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-user-line text-4xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Tự do khám phá mọi nơi</h3>
                  <p className="text-sm text-gray-700 leading-relaxed mb-0">
                    Mỹ là đất nước được thiết kế cho ô tô. Phương tiện công cộng chỉ phát triển ở một số thành phố lớn như New York, San Francisco. Thuê xe giúp bạn tự do di chuyển, khám phá những địa danh tuyệt đẹp mà xe buýt hay tàu điện ngầm không thể đến được.
                  </p>
                </div>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Ưu điểm của việc thuê xe</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {[
                {
                  icon: 'ri-time-line',
                  title: 'Tiết kiệm thời gian',
                  color: 'green',
                  benefits: [
                    'Không cần chờ đợi phương tiện công cộng',
                    'Di chuyển trực tiếp đến đích',
                    'Lịch trình linh hoạt theo ý muốn',
                    'Có thể thay đổi kế hoạch bất cứ lúc nào'
                  ]
                },
                {
                  icon: 'ri-money-dollar-circle-line',
                  title: 'Tiết kiệm chi phí',
                  color: 'blue',
                  benefits: [
                    'Rẻ hơn taxi/Uber cho quãng đường dài',
                    'Chia sẻ chi phí khi đi nhóm',
                    'Không tốn phí tip như taxi',
                    'Có thể mang đồ ăn, nước uống'
                  ]
                },
                {
                  icon: 'ri-map-2-line',
                  title: 'Khám phá sâu rộng',
                  color: 'purple',
                  benefits: [
                    'Đến được những địa điểm xa xôi',
                    'Dừng chân bất cứ đâu để chụp ảnh',
                    'Khám phá đường cao tốc scenic routes',
                    'Ghé thăm các thị trấn nhỏ dọc đường'
                  ]
                },
                {
                  icon: 'ri-shield-check-line',
                  title: 'An toàn & tiện nghi',
                  color: 'orange',
                  benefits: [
                    'Không phụ thuộc vào ai',
                    'Để hành lý an toàn trong xe',
                    'Có điều hòa, GPS, radio',
                    'Riêng tư và thoải mái'
                  ]
                }
              ].map((item, index) => (
                <div key={index} className={`bg-white border-2 border-${item.color}-200 rounded-xl p-6 hover:shadow-lg transition-shadow`}>
                  <div className="w-12 h-12 flex items-center justify-center mb-4">
                    <i className={`${item.icon} text-4xl text-${item.color}-600`}></i>
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 mb-3">{item.title}</h4>
                  <ul className="space-y-2 text-sm text-gray-700">
                    {item.benefits.map((benefit, idx) => (
                      <li key={idx} className="flex items-start gap-2">
                        <i className={`ri-check-line text-${item.color}-600 mt-1`}></i>
                        <span>{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-orange-600 to-red-700 rounded-xl p-8 text-white mb-8">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex-1 min-w-64">
                  <h3 className="text-xl font-bold mb-2">Đã sẵn sàng khám phá nước Mỹ?</h3>
                  <p className="text-sm text-white/90">
                    Khám phá các tour tự lái xe xuyên bang với lịch trình chi tiết, đã bao gồm thuê xe và khách sạn
                  </p>
                </div>
                <button className="bg-white text-orange-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                  Xem Tour Tự Lái →
                </button>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Điều kiện thuê xe tại Mỹ</h3>
            
            <div className="space-y-4 mb-8">
              {[
                {
                  title: 'Bằng lái xe',
                  icon: 'ri-bank-card-line',
                  color: 'blue',
                  requirements: [
                    'Bằng lái quốc tế (International Driving Permit - IDP)',
                    'Bằng lái Việt Nam gốc (phải mang theo)',
                    'Tuổi tối thiểu: 21 tuổi (một số hãng yêu cầu 25 tuổi)',
                    'Kinh nghiệm lái xe tối thiểu 1 năm'
                  ]
                },
                {
                  title: 'Thẻ tín dụng',
                  icon: 'ri-bank-card-2-line',
                  color: 'green',
                  requirements: [
                    'Thẻ tín dụng quốc tế (Visa, Mastercard)',
                    'Hạn mức tối thiểu $1,500-$2,000',
                    'Phải cùng tên với người thuê xe',
                    'Dùng để đặt cọc (deposit) $300-$800'
                  ]
                },
                {
                  title: 'Giấy tờ khác',
                  icon: 'ri-file-list-3-line',
                  color: 'purple',
                  requirements: [
                    'Hộ chiếu có visa Mỹ hợp lệ',
                    'Vé máy bay khứ hồi',
                    'Thông tin liên lạc tại Mỹ',
                    'Email xác nhận đặt xe (nếu đặt online)'
                  ]
                }
              ].map((section, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-6 border border-gray-200">
                  <div className="flex items-start gap-4">
                    <div className={`w-12 h-12 flex items-center justify-center flex-shrink-0 bg-${section.color}-100 rounded-lg`}>
                      <i className={`${section.icon} text-3xl text-${section.color}-600`}></i>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg font-bold text-gray-900 mb-3">{section.title}</h4>
                      <ul className="space-y-2">
                        {section.requirements.map((req, idx) => (
                          <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                            <i className={`ri-arrow-right-s-line text-${section.color}-600 mt-0.5`}></i>
                            <span>{req}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-lg">
              <div className="flex items-start gap-3">
                <i className="ri-error-warning-line text-2xl text-red-600 mt-1"></i>
                <div>
                  <h4 className="text-base font-bold text-red-900 mb-2">Lưu ý quan trọng</h4>
                  <p className="text-sm text-gray-700 mb-0">
                    Bằng lái quốc tế phải xin tại Việt Nam trước khi đi. Tại Mỹ không thể làm thủ tục này. Thời gian xử lý thường 7-10 ngày làm việc. Chi phí khoảng 600,000 VNĐ.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'companies' && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Top hãng thuê xe uy tín tại Mỹ</h2>
            
            <div className="w-full h-80 rounded-xl overflow-hidden mb-8">
              <img
                src="https://readdy.ai/api/search-image?query=Major%20car%20rental%20companies%20counter%20area%20at%20American%20airport%20terminal%20with%20Hertz%20Enterprise%20Budget%20Avis%20logos%2C%20professional%20service%20desk%20with%20multiple%20rental%20cars%20in%20background%2C%20modern%20bright%20airport%20interior%20with%20clear%20signage&width=1200&height=500&seq=rental-companies&orientation=landscape"
                alt="Các hãng thuê xe"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Hãng xe hàng đầu</h3>
            
            <div className="space-y-6 mb-8">
              {[
                {
                  name: 'Enterprise',
                  logo: 'ri-building-line',
                  rating: 4.5,
                  color: 'green',
                  pros: [
                    'Mạng lưới rộng nhất với hơn 7,000 địa điểm',
                    'Dịch vụ đón tận nơi miễn phí',
                    'Đội xe mới, đa dạng loại xe',
                    'Chính sách nhiên liệu linh hoạt'
                  ],
                  cons: [
                    'Giá cao hơn các hãng khác',
                    'Thủ tục check-in hơi lâu'
                  ],
                  price: '$35-80/ngày',
                  bestFor: 'Du lịch gia đình, chuyến đi dài ngày'
                },
                {
                  name: 'Hertz',
                  logo: 'ri-trophy-line',
                  rating: 4.3,
                  color: 'yellow',
                  pros: [
                    'Thương hiệu lâu đời, uy tín cao',
                    'Chương trình khách hàng thân thiết tốt',
                    'Có mặt tại hầu hết sân bay lớn',
                    'Xe sang và xe thể thao đa dạng'
                  ],
                  cons: [
                    'Giá cao, nhiều phí phát sinh',
                    'Chính sách bảo hiểm phức tạp'
                  ],
                  price: '$40-90/ngày',
                  bestFor: 'Khách hàng VIP, thuê xe sang'
                },
                {
                  name: 'Budget',
                  logo: 'ri-money-dollar-circle-line',
                  rating: 4.0,
                  color: 'blue',
                  pros: [
                    'Giá cả phải chăng nhất',
                    'Thường có khuyến mãi tốt',
                    'Thủ tục đơn giản, nhanh chóng',
                    'Phù hợp ngân sách hạn hẹp'
                  ],
                  cons: [
                    'Xe cũ hơn, ít tùy chọn',
                    'Dịch vụ khách hàng cơ bản'
                  ],
                  price: '$25-60/ngày',
                  bestFor: 'Du lịch tiết kiệm, sinh viên'
                },
                {
                  name: 'Avis',
                  logo: 'ri-star-line',
                  rating: 4.2,
                  color: 'red',
                  pros: [
                    'Đối tác với nhiều hãng hàng không',
                    'Quy trình đặt xe online tiện lợi',
                    'Xe chất lượng tốt, bảo dưỡng đều',
                    'Hỗ trợ khách hàng 24/7'
                  ],
                  cons: [
                    'Giá trung bình cao',
                    'Ít địa điểm pickup ngoài sân bay'
                  ],
                  price: '$30-75/ngày',
                  bestFor: 'Chuyến công tác, thuê ngắn hạn'
                }
              ].map((company, index) => (
                <div key={index} className={`bg-white border-2 border-${company.color}-200 rounded-xl p-6 hover:shadow-lg transition-shadow`}>
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-4">
                      <div className={`w-14 h-14 flex items-center justify-center bg-${company.color}-100 rounded-xl`}>
                        <i className={`${company.logo} text-3xl text-${company.color}-600`}></i>
                      </div>
                      <div>
                        <h4 className="text-xl font-bold text-gray-900">{company.name}</h4>
                        <div className="flex items-center gap-2 mt-1">
                          <div className="flex gap-1">
                            {Array.from({ length: 5 }, (_, i) => (
                              <i key={i} className={`ri-star-${i < Math.floor(company.rating) ? 'fill' : 'line'} text-yellow-400 text-sm`}></i>
                            ))}
                          </div>
                          <span className="text-sm text-gray-600">{company.rating}/5</span>
                        </div>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className={`text-lg font-bold text-${company.color}-600`}>{company.price}</div>
                      <div className="text-xs text-gray-500">Giá trung bình</div>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <h5 className="text-sm font-bold text-green-900 mb-2">✅ Ưu điểm</h5>
                      <ul className="space-y-1">
                        {company.pros.map((pro, idx) => (
                          <li key={idx} className="text-xs text-gray-700 flex items-start gap-1">
                            <i className="ri-check-line text-green-600 text-sm mt-0.5"></i>
                            <span>{pro}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h5 className="text-sm font-bold text-red-900 mb-2">❌ Nhược điểm</h5>
                      <ul className="space-y-1">
                        {company.cons.map((con, idx) => (
                          <li key={idx} className="text-xs text-gray-700 flex items-start gap-1">
                            <i className="ri-close-line text-red-600 text-sm mt-0.5"></i>
                            <span>{con}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  
                  <div className={`bg-${company.color}-50 p-3 rounded-lg`}>
                    <span className="text-xs text-gray-600">
                      <strong>Phù hợp nhất:</strong> {company.bestFor}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-blue-600 to-purple-700 rounded-xl p-8 text-white mb-8">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex-1 min-w-64">
                  <h3 className="text-xl font-bold mb-2">So sánh giá thuê xe tốt nhất</h3>
                  <p className="text-sm text-white/90">
                    Sử dụng các trang so sánh giá để tìm deal tốt nhất từ nhiều hãng khác nhau
                  </p>
                </div>
                <button className="bg-white text-blue-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                  So sánh giá →
                </button>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Mẹo chọn hãng xe phù hợp</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              {[
                {
                  scenario: 'Du lịch gia đình',
                  recommendation: 'Enterprise hoặc Hertz',
                  reason: 'Xe rộng rãi, dịch vụ tốt, mạng lưới rộng',
                  tips: 'Chọn SUV hoặc Minivan, mua bảo hiểm đầy đủ'
                },
                {
                  scenario: 'Chuyến đi tiết kiệm',
                  recommendation: 'Budget hoặc Economy brands',
                  reason: 'Giá rẻ nhất, đáp ứng nhu cầu cơ bản',
                  tips: 'Đặt trước online, tránh phí phát sinh'
                },
                {
                  scenario: 'Chuyến công tác',
                  recommendation: 'Avis hoặc Hertz',
                  reason: 'Thủ tục nhanh, xe chất lượng cao',
                  tips: 'Đăng ký thành viên VIP để ưu tiên'
                },
                {
                  scenario: 'Road trip dài ngày',
                  recommendation: 'Enterprise',
                  reason: 'Chính sách đổi xe linh hoạt, hỗ trợ 24/7',
                  tips: 'Thuê xe mới, kiểm tra kỹ trước khi nhận'
                }
              ].map((item, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-5 border border-gray-200">
                  <h4 className="text-base font-bold text-gray-900 mb-2">{item.scenario}</h4>
                  <div className="space-y-2 text-sm">
                    <p><strong className="text-orange-600">Khuyến nghị:</strong> {item.recommendation}</p>
                    <p><strong className="text-blue-600">Lý do:</strong> {item.reason}</p>
                    <p><strong className="text-green-600">Mẹo:</strong> {item.tips}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg">
              <h4 className="text-base font-bold text-yellow-900 mb-2">💡 Bí quyết đặt xe tiết kiệm</h4>
              <p className="text-sm text-gray-700 mb-0">
                Đặt xe trước ít nhất 2 tuần để có giá tốt. So sánh giá trên các trang như Expedia, Priceline, Kayak. Tránh thuê xe tại sân bay vào cuối tuần và ngày lễ. Kiểm tra kỹ điều khoản hủy và đổi lịch trước khi thanh toán.
              </p>
            </div>
          </div>
        )}

        {activeTab === 'driving' && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Luật giao thông và quy tắc lái xe tại Mỹ</h2>
            
            <div className="w-full h-80 rounded-xl overflow-hidden mb-8">
              <img
                src="https://readdy.ai/api/search-image?query=American%20highway%20road%20scene%20with%20clear%20traffic%20signs%20and%20speed%20limit%20boards%2C%20cars%20driving%20safely%20with%20proper%20lane%20discipline%2C%20bright%20daylight%20with%20blue%20sky%2C%20well-maintained%20asphalt%20road%20with%20white%20lane%20markings%20and%20highway%20infrastructure&width=1200&height=500&seq=us-highway-traffic&orientation=landscape"
                alt="Giao thông Mỹ"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="bg-red-50 border border-red-200 rounded-xl p-6 mb-8">
              <h3 className="text-lg font-bold text-red-900 mb-3">🚨 Quy tắc quan trọng nhất</h3>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <i className="ri-steering-2-line text-2xl text-red-600 mt-1"></i>
                  <p className="text-sm text-gray-700">
                    <strong>Lái xe bên phải:</strong> Ngược với Việt Nam, xe đi bên phải đường, vô lăng ở bên trái
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-forbid-line text-2xl text-red-600 mt-1"></i>
                  <p className="text-sm text-gray-700">
                    <strong>Nghiêm cấm:</strong> Uống rượu bia, sử dụng điện thoại khi lái xe. Phạt rất nặng!
                  </p>
                </div>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Quy tắc giao thông cơ bản</h3>
            
            <div className="space-y-6 mb-8">
              {[
                {
                  title: 'Tốc độ & Giới hạn',
                  icon: 'ri-speed-up-line',
                  color: 'red',
                  rules: [
                    {
                      type: 'Cao tốc (Highway)',
                      speed: '65-85 mph (105-137 km/h)',
                      note: 'Tùy theo bang, có thể lên đến 85 mph ở Texas'
                    },
                    {
                      type: 'Đường thành phố',
                      speed: '25-35 mph (40-56 km/h)',
                      note: 'Khu vực trường học giảm xuống 15-20 mph'
                    },
                    {
                      type: 'Đường liên bang',
                      speed: '45-55 mph (72-89 km/h)',
                      note: 'Đường 2 chiều, cần cẩn thận khi vượt'
                    }
                  ]
                },
                {
                  title: 'Right of Way (Quyền ưu tiên)',
                  icon: 'ri-arrow-right-up-line',
                  color: 'blue',
                  rules: [
                    {
                      type: 'Stop Sign (Biển STOP)',
                      speed: 'Dừng hoàn toàn 3 giây',
                      note: 'Ai đến trước đi trước, cùng lúc xe phải nhường xe trái'
                    },
                    {
                      type: 'Yield Sign',
                      speed: 'Nhường đường xe đang đi',
                      note: 'Chỉ đi khi đảm bảo an toàn'
                    },
                    {
                      type: 'Xe cấp cứu',
                      speed: 'Dừng lại ngay lập tức',
                      note: 'Tấp vào lề đường, chờ xe đi qua'
                    }
                  ]
                },
                {
                  title: 'Rẽ & Chuyển làn',
                  icon: 'ri-direction-line',
                  color: 'green',
                  rules: [
                    {
                      type: 'Rẽ phải khi đèn đỏ',
                      speed: 'Được phép (trừ khi có biển cấm)',
                      note: 'Phải dừng hẳn, đảm bảo an toàn mới rẽ'
                    },
                    {
                      type: 'Chuyển làn',
                      speed: 'Bật xi-nhan trước 3 giây',
                      note: 'Kiểm tra điểm mù, đảm bảo khoảng cách an toàn'
                    },
                    {
                      type: 'U-turn',
                      speed: 'Chỉ khi được phép',
                      note: 'Cấm tại giao lộ có đèn, gần khúc cua'
                    }
                  ]
                }
              ].map((section, index) => (
                <div key={index} className={`bg-white border-2 border-${section.color}-200 rounded-xl p-6`}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className={`w-12 h-12 flex items-center justify-center bg-${section.color}-100 rounded-lg`}>
                      <i className={`${section.icon} text-3xl text-${section.color}-600`}></i>
                    </div>
                    <h4 className="text-lg font-bold text-gray-900">{section.title}</h4>
                  </div>
                  <div className="space-y-4">
                    {section.rules.map((rule, idx) => (
                      <div key={idx} className="bg-gray-50 rounded-lg p-4">
                        <div className="flex items-start justify-between mb-2">
                          <h5 className="text-sm font-bold text-gray-900">{rule.type}</h5>
                          <span className={`text-xs font-medium px-2 py-1 rounded bg-${section.color}-100 text-${section.color}-700`}>
                            {rule.speed}
                          </span>
                        </div>
                        <p className="text-xs text-gray-600">{rule.note}</p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Biển báo quan trọng cần nhớ</h3>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
              {[
                { sign: 'STOP', meaning: 'Dừng hẳn', color: 'red', icon: 'ri-stop-line' },
                { sign: 'YIELD', meaning: 'Nhường đường', color: 'yellow', icon: 'ri-arrow-down-line' },
                { sign: 'NO U-TURN', meaning: 'Cấm quay đầu', color: 'red', icon: 'ri-forbid-line' },
                { sign: 'ONE WAY', meaning: 'Đường một chiều', color: 'blue', icon: 'ri-arrow-right-line' },
                { sign: 'DO NOT ENTER', meaning: 'Cấm vào', color: 'red', icon: 'ri-close-circle-line' },
                { sign: 'SPEED LIMIT', meaning: 'Giới hạn tốc độ', color: 'green', icon: 'ri-speed-line' },
                { sign: 'SCHOOL ZONE', meaning: 'Khu vực trường học', color: 'yellow', icon: 'ri-school-line' },
                { sign: 'PEDESTRIAN', meaning: 'Người đi bộ', color: 'orange', icon: 'ri-walk-line' }
              ].map((item, index) => (
                <div key={index} className={`bg-${item.color}-50 border border-${item.color}-200 rounded-lg p-4 text-center`}>
                  <div className={`w-8 h-8 mx-auto mb-2 flex items-center justify-center`}>
                    <i className={`${item.icon} text-2xl text-${item.color}-600`}></i>
                  </div>
                  <div className="text-xs font-bold text-gray-900">{item.sign}</div>
                  <div className="text-xs text-gray-600 mt-1">{item.meaning}</div>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-xl p-8 text-white mb-8">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex-1 min-w-64">
                  <h3 className="text-xl font-bold mb-2">Lái xe an toàn với GPS</h3>
                  <p className="text-sm text-white/90">
                    Khám phá các tour tự lái với lộ trình GPS chi tiết, đã tính toán thời gian và điểm dừng chân
                  </p>
                </div>
                <button className="bg-white text-purple-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                  Xem lộ trình GPS →
                </button>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Tình huống đặc biệt</h3>
            
            <div className="space-y-4 mb-8">
              {[
                {
                  situation: '🚌 Xe buýt trường học dừng',
                  action: 'Dừng hẳn xe, chờ xe buýt đi',
                  warning: 'Phạt rất nặng nếu vi phạm ($400-1000)',
                  details: 'Khi đèn đỏ nhấp nháy và biển STOP mở ra, tất cả xe phải dừng cả 2 chiều'
                },
                {
                  situation: '🚑 Xe cứu thương, cảnh sát',
                  action: 'Tấp vào lề phải ngay lập tức',
                  warning: 'Cản trở xe cấp cứu là tội hình sự',
                  details: 'Nghe còi báo động, nhìn thấy đèn xanh dương đỏ phải nhường đường ngay'
                },
                {
                  situation: '🚧 Khu vực thi công',
                  action: 'Giảm tốc độ, theo người điều khiển',
                  warning: 'Phạt gấp đôi trong khu vực công trình',
                  details: 'Tốc độ giảm xuống 25-45 mph tùy theo biển báo'
                },
                {
                  situation: '🦌 Động vật hoang dã',
                  action: 'Giảm tốc độ, không rẽ lái đột ngột',
                  warning: 'Thường xảy ra lúc hoàng hôn/rạng sáng',
                  details: 'Nếu không tránh được, đâm thẳng tốt hơn rẽ lái và mất kiểm soát'
                }
              ].map((item, index) => (
                <div key={index} className="bg-white border-l-4 border-orange-500 rounded-r-xl p-6 shadow-sm">
                  <h4 className="text-base font-bold text-gray-900 mb-2">{item.situation}</h4>
                  <div className="space-y-2 text-sm">
                    <p><strong className="text-green-600">Hành động:</strong> {item.action}</p>
                    <p><strong className="text-red-600">Cảnh báo:</strong> {item.warning}</p>
                    <p><strong className="text-blue-600">Chi tiết:</strong> {item.details}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-lg">
              <h4 className="text-base font-bold text-blue-900 mb-2">📱 Apps hữu ích cho lái xe</h4>
              <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">
                <div>
                  <p><strong>Waze:</strong> GPS thông minh, tránh kẹt xe</p>
                  <p><strong>GasBuddy:</strong> Tìm trạm xăng giá rẻ</p>
                </div>
                <div>
                  <p><strong>ParkWhiz:</strong> Đặt chỗ đậu xe trước</p>
                  <p><strong>Roadside America:</strong> Điểm du lịch độc đáo</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'tips' && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Bí quyết tiết kiệm và an toàn</h2>
            
            <div className="bg-gradient-to-r from-green-50 to-blue-50 border-2 border-green-300 rounded-xl p-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-16 h-16 flex items-center justify-center flex-shrink-0">
                  <i className="ri-lightbulb-flash-line text-5xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">12 năm kinh nghiệm thực tế</h3>
                  <p className="text-sm text-gray-700 mb-0">
                    Tôi đã thuê xe và lái xe qua 35 bang của Mỹ, từ bờ Đông sang bờ Tây, từ Alaska xuống Florida. Dưới đây là những bí quyết quý báu giúp bạn tiết kiệm tiền và đảm bảo an toàn.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-6 mb-8">
              {[
                {
                  title: 'Tiết kiệm chi phí thuê xe',
                  icon: 'ri-coins-line',
                  color: 'green',
                  tips: [
                    {
                      tip: 'Đặt trước và so sánh giá',
                      detail: 'Đặt trước 2-4 tuần để có giá tốt. Dùng Expedia, Priceline, Costco Travel để so sánh',
                      savings: 'Tiết kiệm 20-40%'
                    },
                    {
                      tip: 'Tránh thuê tại sân bay',
                      detail: 'Thuê tại các văn phòng trong thành phố rẻ hơn 10-25%. Có thể đi taxi đến đó',
                      savings: 'Tiết kiệm $10-30/ngày'
                    },
                    {
                      tip: 'Chọn xe nhỏ gọn',
                      detail: 'Xe Economy/Compact đủ cho 2-3 người, tiết kiệm cả tiền thuê và xăng',
                      savings: 'Tiết kiệm $15-25/ngày'
                    },
                    {
                      tip: 'Từ chối bảo hiểm thừa',
                      detail: 'Kiểm tra thẻ tín dụng và bảo hiểm du lịch, có thể đã bao gồm bảo hiểm xe',
                      savings: 'Tiết kiệm $15-30/ngày'
                    }
                  ]
                },
                {
                  title: 'Tiết kiệm nhiên liệu',
                  icon: 'ri-gas-station-line',
                  color: 'orange',
                  tips: [
                    {
                      tip: 'Sử dụng app GasBuddy',
                      detail: 'Tìm trạm xăng giá rẻ nhất trong khu vực. Thường Costco, Sam\'s Club rẻ nhất',
                      savings: 'Tiết kiệm $0.10-0.30/gallon'
                    },
                    {
                      tip: 'Đổ xăng sáng sớm',
                      detail: 'Xăng đặc hơn khi nhiệt độ thấp, được nhiều xăng hơn với cùng số tiền',
                      savings: 'Tiết kiệm 2-3%'
                    },
                    {
                      tip: 'Lái xe êm ái',
                      detail: 'Tránh tăng tốc đột ngột, giữ tốc độ ổn định, sử dụng cruise control',
                      savings: 'Tiết kiệm 15-25% xăng'
                    },
                    {
                      tip: 'Trả xe đầy bình',
                      detail: 'Đổ đầy tại trạm xăng gần nơi trả xe để tránh phí đổ xăng của hãng',
                      savings: 'Tránh phí $3-5/gallon'
                    }
                  ]
                },
                {
                  title: 'An toàn khi lái xe',
                  icon: 'ri-shield-check-line',
                  color: 'blue',
                  tips: [
                    {
                      tip: 'Kiểm tra xe trước khi nhận',
                      detail: 'Chụp ảnh mọi vết xước, kiểm tra lốp, đèn, gương. Báo ngay nếu có vấn đề',
                      savings: 'Tránh bị tính phí sửa chữa'
                    },
                    {
                      tip: 'Luôn khóa xe và cất giấy tờ',
                      detail: 'Không để đồ giá trị trong xe, đặc biệt ở các thành phố lớn',
                      savings: 'Tránh mất trộm tài sản'
                    },
                    {
                      tip: 'Nghỉ ngơi đủ giấc',
                      detail: 'Dừng 15 phút sau mỗi 2 tiếng lái xe. Không lái xe khi buồn ngủ',
                      savings: 'Tránh tai nạn'
                    },
                    {
                      tip: 'Chuẩn bị cho thời tiết xấu',
                      detail: 'Kiểm tra dự báo thời tiết, mang theo đồ ấm, nước, đồ ăn nhẹ',
                      savings: 'Tránh gặp khó khăn'
                    }
                  ]
                },
                {
                  title: 'Mẹo đậu xe tiết kiệm',
                  icon: 'ri-parking-box-line',
                  color: 'purple',
                  tips: [
                    {
                      tip: 'Dùng app tìm chỗ đậu',
                      detail: 'SpotHero, ParkWhiz giúp đặt chỗ trước với giá rẻ hơn',
                      savings: 'Tiết kiệm 30-50%'
                    },
                    {
                      tip: 'Đậu xa trung tâm',
                      detail: 'Đi bộ hoặc dùng phương tiện công cộng vào trung tâm',
                      savings: 'Tiết kiệm $20-50/ngày'
                    },
                    {
                      tip: 'Tìm hiểu giờ miễn phí',
                      detail: 'Nhiều nơi miễn phí đậu xe sau 6 PM, cuối tuần, hoặc ngày lễ',
                      savings: 'Miễn phí hoàn toàn'
                    },
                    {
                      tip: 'Ở khách sạn có bãi đậu',
                      detail: 'Chọn khách sạn bao gồm parking miễn phí thay vì ở downtown',
                      savings: 'Tiết kiệm $15-40/đêm'
                    }
                  ]
                }
              ].map((section, index) => (
                <div key={index} className={`bg-white border-2 border-${section.color}-200 rounded-xl p-6 hover:shadow-lg transition-shadow`}>
                  <div className="flex items-center gap-3 mb-6">
                    <div className={`w-12 h-12 flex items-center justify-center bg-${section.color}-100 rounded-lg`}>
                      <i className={`${section.icon} text-3xl text-${section.color}-600`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900">{section.title}</h3>
                  </div>
                  <div className="space-y-4">
                    {section.tips.map((item, idx) => (
                      <div key={idx} className="bg-gray-50 rounded-lg p-4 border-l-4 border-{section.color}-400">
                        <div className="flex items-start justify-between mb-2">
                          <h4 className="text-sm font-bold text-gray-900 flex-1">{item.tip}</h4>
                          <span className={`text-xs font-medium px-2 py-1 rounded bg-${section.color}-100 text-${section.color}-700 whitespace-nowrap ml-2`}>
                            {item.savings}
                          </span>
                        </div>
                        <p className="text-sm text-gray-600">{item.detail}</p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-teal-600 to-blue-700 rounded-xl p-8 text-white mb-8">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-roadster-line text-5xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-3">Sẵn sàng khám phá nước Mỹ bằng xe?</h3>
                <p className="text-base text-white/90 mb-6 max-w-2xl mx-auto">
                  Tham gia các tour tự lái được thiết kế chuyên nghiệp với lộ trình tối ưu, hỗ trợ 24/7 và kinh nghiệm địa phương
                </p>
                <div className="flex flex-wrap gap-4 justify-center">
                  <button className="bg-white text-teal-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                    Tour Tây Bắc →
                  </button>
                  <button className="bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer">
                    Tour California →
                  </button>
                </div>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Checklist trước chuyến đi</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-green-50 border border-green-200 rounded-lg p-5">
                <h4 className="text-base font-bold text-green-900 mb-3">✅ Trước khi đi</h4>
                <ul className="space-y-2 text-sm text-gray-700">
                  {[
                    'Làm bằng lái quốc tế (IDP)',
                    'Kiểm tra hạn mức thẻ tín dụng',
                    'Mua bảo hiểm du lịch',
                    'Tải app GPS offline',
                    'Nghiên cứu luật giao thông bang sẽ đến',
                    'Đặt xe trước với giá tốt',
                    'Lên kế hoạch lộ trình chi tiết'
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-green-600 text-lg mt-0.5"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-5">
                <h4 className="text-base font-bold text-blue-900 mb-3">📋 Khi nhận xe</h4>
                <ul className="space-y-2 text-sm text-gray-700">
                  {[
                    'Kiểm tra ngoại thất, chụp ảnh vết xước',
                    'Test đèn, còi, điều hòa, radio',
                    'Kiểm tra mức xăng, áp suất lốp',
                    'Tìm hiểu cách sử dụng GPS',
                    'Lưu số điện thoại hỗ trợ 24/7',
                    'Đọc kỹ hợp đồng trước khi ký',
                    'Hỏi về chính sách đổ xăng'
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-blue-600 text-lg mt-0.5"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg">
              <h4 className="text-base font-bold text-yellow-900 mb-2">🏆 Lời khuyên cuối cùng</h4>
              <p className="text-sm text-gray-700 mb-0">
                Thuê xe tại Mỹ không khó, quan trọng là <strong>chuẩn bị kỹ càng và lái xe cẩn thận</strong>. Hãy nhớ rằng, an toàn luôn là ưu tiên hàng đầu. Đừng ngần ngại dừng lại nghỉ ngơi khi mệt mỏi. Chúc bạn có một chuyến road trip tuyệt vời và an toàn!
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Bottom CTA */}
      <div className="mt-12 bg-gradient-to-r from-gray-900 to-gray-800 rounded-xl p-8 text-white">
        <div className="flex items-center justify-between flex-wrap gap-6">
          <div className="flex-1 min-w-64">
            <h3 className="text-xl font-bold mb-2">Cần hỗ trợ thuê xe hoặc lập kế hoạch?</h3>
            <p className="text-sm text-gray-300">
              Liên hệ với chúng tôi để được tư vấn miễn phí về thuê xe và lên lộ trình du lịch tự lái
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <button className="bg-orange-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer">
              Tư vấn miễn phí
            </button>
            <button className="bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer">
              Xem Tour Tự Lái
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}
